import { Classes as CoreClasses } from "@blueprintjs/core";
import {
  DatePicker3,
  DateRangePicker3,
  DateRangePicker3Props,
  ReactDayPickerClasses,
} from "@blueprintjs/datetime2";
import { rgba } from "polished";
import styled, { css } from "styled-components";

import { STATIC_ICON } from "../components/icons/staticIcons.js";

import { htmlSelectStyles } from "./HexHTMLSelect.js";

export type DateRange = [Date | null, Date | null];

export const dateRangePickerStyles = css`
  color: ${({ theme }) => theme.fontColor.DEFAULT};

  background-color: ${({ theme }) => theme.backgroundColor.DEFAULT};

  .${ReactDayPickerClasses.RDP_CAPTION} {
    border-color: ${({ theme }) => theme.borderColor.MUTED};

    select {
      color: ${({ theme }) => theme.fontColor.DEFAULT};
    }

    .${ReactDayPickerClasses.RDP_CAPTION_DROPDOWNS} {
      .${CoreClasses.ICON} {
        background-color: ${({ theme }) => theme.iconColor};
        background-image: none;
        mask-image: ${`url('data:image/svg+xml,${STATIC_ICON.ChevronExpand}')`};
        svg {
          visibility: hidden;
        }
      }
    }

    .${CoreClasses.HTML_SELECT} {
      ${htmlSelectStyles}
    }
  }

  .${CoreClasses.DIVIDER} {
    border-color: ${({ theme }) => theme.borderColor.MUTED};
  }

  .${CoreClasses.MENU} {
    background-color: inherit;
    color: inherit;
  }

  .${ReactDayPickerClasses.RDP_NAV} {
    .${CoreClasses.ICON} {
      background-color: ${({ theme }) => theme.iconColor};
      background-image: none;
      svg {
        visibility: hidden;
      }
    }
    .${CoreClasses.BUTTON}:first-child {
      .${CoreClasses.ICON} {
        mask-image: ${`url('data:image/svg+xml,${STATIC_ICON.SingleChevronLeft}')`};
      }
    }
    .${CoreClasses.BUTTON}:last-child {
      .${CoreClasses.ICON} {
        mask-image: ${`url('data:image/svg+xml,${STATIC_ICON.SingleChevronRight}')`};
      }
    }
  }

  .rdp-head_cell {
    font-weight: ${({ theme }) => theme.fontWeight.NORMAL};
  }

  .rdp-day {
    color: ${({ theme }) => theme.fontColor.DEFAULT};

    /* Default button */
    &:not([disabled]):not(.rdp-day_selected):hover {
      color: ${({ theme }) => theme.fontColor.DEFAULT};
      background-color: ${({ theme }) => theme.hoverColor};
    }

    /* Selected date */
    &.rdp-day_selected {
      color: ${({ theme }) => theme.intent.PRIMARY};
      background-color: ${({ theme }) => rgba(theme.intent.PRIMARY, 0.2)};
      &:hover {
        color: ${({ theme }) => theme.intent.PRIMARY};
        background-color: ${({ theme }) => rgba(theme.intent.PRIMARY, 0.3)};
      }
    }

    /* Range selection */
    &.rdp-day_hovered:not(.rdp-day_selected):not(.rdp-day_range_start):not(
        .rdp-day_range_middle
      ):not(.rdp-day_range_end) {
      color: ${({ theme }) => theme.intent.PRIMARY};
      background-color: ${({ theme }) => rgba(theme.intent.PRIMARY, 0.075)};
      &:hover {
        background-color: ${({ theme }) => rgba(theme.intent.PRIMARY, 0.1)};
      }
    }

    /* Days outside of the current month */
    &.rdp-day_outside {
      color: ${({ theme }) => theme.fontColor.MUTED};
      opacity: 1;
    }
  }
`;

export type HexDateRangePickerProps = DateRangePicker3Props & {
  allowSingleDayRange?: boolean;
};

export const HexDateRangePicker = styled(DateRangePicker3)`
  ${dateRangePickerStyles}
`;

export const HexDatePicker = styled(DatePicker3)`
  ${dateRangePickerStyles}
`;
